/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import Downshift from 'downshift';
import { useEffect, useState } from 'react';
import { IMeiliSearchHitsItem } from '../../../modules/sport/interfaces/defy';
import { Hit, MeiliSearch } from 'meilisearch';
import Image from '../../Image';
import Blanca from '../../components/images/blanca.png';
import { useAuth } from '../../../context/auth-context';
interface AutocompleteProps {
    sportId: string;
    setChallengedTeam: any;
    challengedTeam: any;
}

const clientSearch = {
    host: process.env.REACT_APP_MEILISEARCH_HOST || '',
    apiKey: process.env.REACT_APP_MEILISEARCH_APIKEY || '',
};

export default function SearchMeili(props: AutocompleteProps) {
    const { sportId, setChallengedTeam, challengedTeam } = props;
    const [inputValue, setInputValue] = useState<string>('');
    const [userID, setUserId] = useState<string>('');

    const [resultsSearch, setMeiliResults] = useState([]);
    const [isOpenMeili, setIsOpenMeili] = useState<boolean>(false);
    const auth = useAuth();

    const clientSearch = new MeiliSearch({
        host: process.env.REACT_APP_MEILISEARCH_HOST || '',
        apiKey: process.env.REACT_APP_MEILISEARCH_APIKEY || '',
    });

    useEffect(() => {
        if (auth && auth.isLoggedIn && auth.user) {
            setUserId(auth.user.userId);
            //console.log({ auth });
        }
    }, [auth]);

    const searchMeili = async (word) => {
        if (word) {
            const index = clientSearch.index(process.env.REACT_APP_MEILI_SEARCH_INDEX || '');
            const filter = [`sportId = '${sportId}'`];
            if (userID && userID !== '') {
                filter.push(`userId != '${userID}'`);
            }
            filter.join(' AND ');
            const result = await (
                await index
            ).search(word, {
                filter: filter,
            });

            if (result && result.hits) {
                //console.log('aqui cambie a verdadero');
                setIsOpenMeili(true);
                const hits: Hit<Record<string, IMeiliSearchHitsItem>>[] = result.hits;
                setMeiliResults(result.hits);
            } else {
                setIsOpenMeili(false);
            }
        }
    };

    useEffect(() => {
        searchMeili(inputValue);
    }, [inputValue]);

    /*useEffect(() => {
        console.log({ isOpenMeili });
    }, [isOpenMeili]);*/

    /* useEffect(() => {
        console.log({ challengedTeam });
    }, [challengedTeam]);*/

    /*useEffect(() => {
        console.log({ resultsSearch });
    }, [resultsSearch]);*/

    const onChange = (value) => {
        //setInputValue(value.name);
        setChallengedTeam(value);
        setIsOpenMeili(false);
        setMeiliResults([]);
        //console.log('onChange Seleccionado:', value);
    };

    const inputOnChange = (event) => {
        setChallengedTeam(null);
        event.preventDefault();
        /*if (!event.target.value) {
            return;
        }*/
        setInputValue(event.target.value);
    };

    return (
        <>
            <Downshift
                onChange={(selection) => onChange(selection)}
                itemToString={(item) => (item && item.name ? item.name : '')}
            >
                {({ getItemProps, getMenuProps, highlightedIndex }) => (
                    <div className="m-1 md:m-auto w-full">
                        <div className="m-auto mt-1 md:mt-6">
                            <label className="relative text-gray-400 focus-within:text-gray-600 block  pt-2 mt-4 ">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`pointer-events-none w-8 h-8 absolute  top-9 transform  -translate-y-1/2 pb-1 right-3`}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" />
                                </svg>
                                <label
                                    htmlFor={'search'}
                                    className={`text-sm-blue-primary font-semibold pl-2 pointer-events-none absolute left-0 -top-3.5  text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm`}
                                >
                                    {'Buscar Equipos'}
                                </label>
                                <input
                                    className={`form-input p-4 border-2 rounded-xl  shadow-profile mb-2 py-3 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block pr-14 focus:outline-none border-gray-300`}
                                    placeholder={'Buscar por nombre de equipo rival'}
                                    onChange={inputOnChange}
                                    value={inputValue}
                                />
                                <ul className="rounded  bg-gray-100" {...getMenuProps()}>
                                    {isOpenMeili &&
                                        resultsSearch &&
                                        resultsSearch.length > 0 &&
                                        resultsSearch.slice(0, 10).map((item, index) => (
                                            <>
                                                {' '}
                                                <li
                                                    {...getItemProps({
                                                        key: item.id,
                                                        index,
                                                        item,
                                                        className: `flex py-2 px-2 cursor-pointer items-center justify-center content-center ${
                                                            highlightedIndex === index
                                                                ? 'bg-sm-rent text-white  font-bold'
                                                                : 'bg-white'
                                                        }`,
                                                    })}
                                                >
                                                    <Image
                                                        className={`flex-none bg-sm-blue-primary hover:border-black rounded-full border-2 shadow-profile border-white  p-2`}
                                                        src={item.logo ? item.logo : Blanca}
                                                        alt={'team'}
                                                        height={30}
                                                        width={30}
                                                        imgClassName={`rounded-full`}
                                                    />
                                                    <span className="min-w-0 relative flex-auto items-center justify-center content-center pl-4">
                                                        {item.name}
                                                    </span>
                                                </li>
                                            </>
                                        ))}
                                </ul>
                            </label>
                        </div>
                    </div>
                )}
            </Downshift>
            {challengedTeam && challengedTeam.name && resultsSearch.length === 0 && (
                <>
                    {' '}
                    <span className={`text-sm-blue-primary  font-bold`}>Equipo seleccionado:</span>
                    <div
                        className={`flex py-2 px-2 cursor-pointer items-center justify-center rounded-full content-center bg-sm-defy-green  text-sm-blue-primary  font-bold`}
                    >
                        <Image
                            className={`flex-none bg-sm-blue-primary hover:border-black rounded-full border-2 shadow-profile border-white  p-2`}
                            src={challengedTeam.logo ? challengedTeam.logo : Blanca}
                            alt={'team'}
                            height={30}
                            width={30}
                            imgClassName={`rounded-full`}
                        />
                        <span className="min-w-0 relative flex-auto items-center justify-center content-center pl-4">
                            {challengedTeam.name} / {challengedTeam.review}
                        </span>
                    </div>
                </>
            )}
        </>
    );
}
